import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/disclaimer")({
  head: () => ({
    meta: [
      { title: "إخلاء المسؤولية — Rawan UI" },
      { name: "description", content: "إخلاء المسؤولية الخاص بموقع Rawan UI لعرض الأفلام والمسلسلات." },
    ],
  }),
  component: DisclaimerPage,
});

function DisclaimerPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="disclaimer"
          titleAr="إخلاء المسؤولية"
          titleEn="Disclaimer"
          titleFr="Avertissement"
          defaultParagraphsAr={[
            "## استضافة المحتوى\n\nالموقع **لا يستضيف** أي ملفات على خوادمه، وجميع الروابط المتاحة عبارة عن إحالات لمصادر طرف ثالث متوفرة علناً على الإنترنت.",
            "## المسؤولية\n\nنحن غير مسؤولين عن دقة أو شرعية أو محتوى تلك المصادر الخارجية، وأي مطالبات بحقوق الملكية يجب توجيهها لأصحاب المحتوى الأصليين.",
            "## حقوق النشر\n\nإذا كنت صاحب حق نشر وتعتقد أن أحد الروابط ينتهك حقوقك، تواصل معنا عبر [صفحة الاتصال](/contact) وسنقوم بإزالته فوراً.",
          ]}
          defaultParagraphsEn={[
            "## Hosting\n\nThis site **does not host** any files on its servers. All links reference publicly available third-party sources.",
            "## Responsibility\n\nWe are not responsible for the accuracy, legality, or content of those external sources. Copyright claims should be directed to the original owners.",
            "## Copyright\n\nIf you are a rights holder and believe a link infringes your copyright, contact us via the [contact page](/contact) and we will remove it promptly.",
          ]}
          defaultParagraphsFr={[
            "## Hébergement\n\nCe site **n'héberge aucun** fichier sur ses serveurs. Tous les liens renvoient vers des sources tierces publiquement disponibles.",
            "## Responsabilité\n\nNous ne sommes pas responsables de l'exactitude, de la légalité ou du contenu de ces sources externes. Les réclamations doivent être adressées aux propriétaires d'origine.",
            "## Droits d'auteur\n\nSi vous êtes ayant droit et estimez qu'un lien enfreint vos droits, contactez-nous via la [page de contact](/contact).",
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
